import { useState } from 'react';
import useToken from '../useToken';
import axios from 'axios';
import { useEffect } from 'react';



export default function useBasket() {
    const { token } = useToken();
    const [basket, setBasket] = useState()
    const [updateBasket, setUpdateBasket] = useState(false)

    useEffect(() => {
        if (!basket) {
            setUpdateBasket(true)
            setBasket(JSON.parse(sessionStorage.getItem("basket")))
            setUpdateBasket(false)
        }
    }
    )
    const addItemToBasket = async (itemProduct) => {
        const basket = await JSON.parse(sessionStorage.getItem("basket"))
        if (basket != null) {
            if (itemProduct.sn != "") {
                const item = basket.find(item => item.sn === itemProduct.sn)
                if (item != null) {
                    alert("Cерийный номер уже есть в корзине")
                    return;
                }
                basket.push(itemProduct)
                sessionStorage.setItem("basket", JSON.stringify(basket))
            }
            else {
                const item = basket.find(item => item.id === itemProduct.id)
                if (item) {
                    const indexItem = basket.indexOf(item)
                    let itemQuantity = item.quantity
                    itemQuantity = (itemQuantity + itemProduct.quantity)
                    basket[indexItem].quantity = itemQuantity
                }
                else {
                    basket.push(itemProduct)
                }
                sessionStorage.setItem("basket", JSON.stringify(basket))
            }
        }
        else {
            const array = new Array(itemProduct)
            sessionStorage.setItem("basket", JSON.stringify(array))
        }
        setBasket(await JSON.parse(sessionStorage.getItem("basket")))

    }
    const removeItem = async (e) => {
        const id = e.currentTarget.getAttribute("data-id")
        const sn = e.currentTarget.getAttribute("data-sn")
        setUpdateBasket(true)

        const basket = await JSON.parse(sessionStorage.getItem("basket"))
        if (sn != null || sn != "") {
            const item = basket.find(item => item.sn === sn)
            const indexItem = basket.indexOf(item)
            // console.log(indexItem)
            basket.splice(indexItem, 1)
        }
        else if (id) {
            const item = basket.find(item => item.id === id)
            const indexItem = basket.indexOf(item)
            basket.splice(indexItem, 1)
        }

        sessionStorage.setItem("basket", JSON.stringify(basket))
        setBasket(JSON.parse(sessionStorage.getItem("basket")))
        setUpdateBasket(false)

    }
    const updateItem = async (e) => {
        setUpdateBasket(true)

        const newQuantity = e.currentTarget.closest("div").querySelector("input").value
        const id = e.currentTarget.getAttribute("data-id")
        const basket = await JSON.parse(sessionStorage.getItem("basket"))
        const item = basket.find(item => item.id == id)

        if (item) {
            if (newQuantity <= 0) {
                const item = basket.find(item => item.id === id)
                const indexItem = basket.indexOf(item)
                basket.splice(indexItem, 1)
            } else {
                const indexItem = basket.indexOf(item)
                let itemQuantity = item.quantity
                basket[indexItem].quantity = parseFloat(newQuantity)
            }
        }

        sessionStorage.setItem("basket", JSON.stringify(basket))
        setBasket(JSON.parse(sessionStorage.getItem("basket")))
        setUpdateBasket(false)
    }
    const addItem = async (data) => {
        setUpdateBasket(true)
        if (data.quantity == null) {
            data.quantity = 1
        }
        axios.get(`api/products/${data.id}`, {
            headers: {
                Authorization: "Bearer " + token
            }
        }).then((response) => {
            const product = response.data
            const itemProduct = {
                id: product.id,
                name: product.name,
                price: product.price,
                quantity: parseInt(data.quantity),
                sn: (data.sn ? data.sn : "")
            }
            addItemToBasket(itemProduct)
            setUpdateBasket(false)
        }
        )
    }
    const resetBasket = () => {
        sessionStorage.removeItem("basket")
        setBasket(null)
    }

    return {
        addItem,
        removeItem,
        updateItem,
        resetBasket,
        basket: basket,
        updateBasket: updateBasket,
    };
}